import { useState, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { BackButton } from '@twa-dev/sdk/react'

import { BabyNotificationType } from 'types'
import { FlexLayout } from 'layouts'
import { useValueContext } from 'contexts'
import { Button, IntervalInputs, Switch } from 'components'
import { getNotificationName, getNotificationIcon } from 'utils'

import './styles.scss'

const getTitle = (notificationType: BabyNotificationType) => (
  <>
    {getNotificationIcon(notificationType)}
    <b>{getNotificationName(notificationType)}</b>
  </>
)

export const EditNotification = observer(() => {
  const { editableNotification, setEditableNotification, editBabyNotification, loading } =
    useValueContext()

  const [isEnabled, setIsEnabled] = useState(editableNotification?.isEnabled ?? false)
  const [time, setTime] = useState(editableNotification?.time ?? { hours: 1, minutes: 30 })

  const navigate = useNavigate()

  const handleEnabledChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setIsEnabled(e.target.checked)
  }, [])

  const handleIntervalChange = useCallback(
    (field: string) => (value: string | number) => {
      setTime((currTime: any) => ({ ...currTime, [field]: value }))
    },
    [],
  )

  const handleSave = () => {
    setEditableNotification({ ...editableNotification, isEnabled, time })
    editBabyNotification()
  }

  if (!editableNotification) {
    navigate('/profile')
    return null
  }

  return (
    <>
      <BackButton />
      <FlexLayout.Container className="with-mobile-indent" vertical>
        <div className="page-title">Редактирование напоминания</div>
        <FlexLayout.Content className="scrollable-layout edit-notification" scrollable>
          <div className="notification-type">{getTitle(editableNotification.tag)}</div>

          <Switch checked={isEnabled} onChange={handleEnabledChange} />
          {isEnabled && (
            <div className="notification-interval">
              <div className="title">Период повтора</div>
              <IntervalInputs
                hoursValue={time.hours}
                minutesValue={time.minutes}
                hoursFieldName="hours"
                minutesFieldName="minutes"
                onChange={handleIntervalChange}
              />
            </div>
          )}
        </FlexLayout.Content>
        <div className="event-footer">
          <Button width="100%" disabled={loading} onClick={handleSave}>
            Сохранить изменения
          </Button>
        </div>
      </FlexLayout.Container>
    </>
  )
})
